const UPDATES_DATA = [
  { time: '10分钟前', title: '某知名导演新片选角现场独家路透曝光', category: '影视', hot: true },
  { time: '28分钟前', title: '顶流歌手演唱会突发状况引全场尖叫', category: '音乐', hot: true },
  { time: '1小时前', title: '热门综艺录制嘉宾名单被提前泄露', category: '综艺', hot: false },
  { time: '2小时前', title: '女星红毯造型引发全网热议与模仿', category: '时尚', hot: false },
  { time: '3小时前', title: '知名演员深夜发文疑似回应此前争议', category: '明星', hot: false },
  { time: '5小时前', title: '娱乐公司高层变动或将影响多部作品', category: '行业', hot: false },
  { time: '7小时前', title: '年度最佳电视剧评选投票通道正式开启', category: '影视', hot: false },
  { time: '9小时前', title: '新晋流量偶像代言品牌销量创历史新高', category: '商业', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-flashlight-line text-primary-500 mr-2"></i>最新快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪，不错过每一条吃瓜动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
            {UPDATES_DATA.map((item, idx) => (
              <div key={idx} className={`relative pb-8 last:pb-0 ${idx === 0 ? '' : ''}`}>
                <div className={`absolute -left-[25px] md:-left-[29px] w-4 h-4 rounded-full border-2 border-background-50 ${
                  item.hot ? 'bg-primary-500 border-primary-500' : 'bg-background-300 border-background-200'
                } ring-2 ring-background-50`}></div>

                <div className="bg-background-100/70 border border-background-200/60 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <div className="flex items-center gap-2 shrink-0">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                      {item.hot && (
                        <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-600 text-[10px] font-bold whitespace-nowrap">
                          热点
                        </span>
                      )}
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-400 bg-background-200/60 px-2 py-0.5 rounded whitespace-nowrap ml-auto">
                      {item.category}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-200 text-primary-500 text-sm font-medium cursor-pointer hover:bg-primary-50 transition-colors whitespace-nowrap">
              <i className="ri-refresh-line"></i>
              查看更多快讯
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}